export const TRADE_IN_TOOL_CONTAINER_SCRIPT_SRC = 'https://trade-in.edmunds.com/static/js/edm-eva.js';
export const TRADE_IN_TOOL_TARGET_CLASS = 'edmunds-trade-in';
export const DEMO_DEALER_ID = '1879141';
export const DEMO_CONFIG_MAKE = 'daewoo';
